module.exports = __webpack_public_path__ + "9972c6f118bbf713ad3a166a9f2f692f.jpg";